
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[locationSlug]/[id]/reviews",
      function () {
        return require("private-next-pages/stores/[locationSlug]/[id]/reviews.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[locationSlug]/[id]/reviews"])
      });
    }
  